import { render, staticRenderFns } from "./ReportAnalysis.vue?vue&type=template&id=9528b8cc&scoped=true"
import script from "./ReportAnalysis.vue?vue&type=script&lang=js"
export * from "./ReportAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ReportAnalysis.vue?vue&type=style&index=0&id=9528b8cc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9528b8cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9528b8cc')) {
      api.createRecord('9528b8cc', component.options)
    } else {
      api.reload('9528b8cc', component.options)
    }
    module.hot.accept("./ReportAnalysis.vue?vue&type=template&id=9528b8cc&scoped=true", function () {
      api.rerender('9528b8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/PlanDetails/components/ReportAnalysis.vue"
export default component.exports